import { ProviderSearchOptions } from 'store/providerSearch/search/types';

export const STORAGE_KEY = '@RECENT_SEARCH';

export type addSearchSignature = (
  userId: string,
  query: string,
  searchParams: any
) => Promise<RecentSearch | boolean>;
export type getSignature = (userId: string, query: string) => Promise<RecentSearch | boolean>;
export type getManySignature = (queries: string[]) => Promise<RecentSearch[]>;
export type getAllSignature = (userId: string) => Promise<RecentSearch[]>;
export type setSignature = (
  userId: string,
  query: string,
  params: any
) => Promise<RecentSearch | boolean>;
export type forgetSignature = (userId: string, query: string) => Promise<boolean>;

export interface StorageInterface {
  get: getSignature;
  getManyByQueryKey: getManySignature;
  getAllRecentSearches: getAllSignature;
  set: setSignature;
  forget: forgetSignature;
}

export interface RecentSearchParams {
  orderBy: string;
  limit: number;
  page: number;
  myPCPList: any[];
  location: Array<{
    lat: number;
    lng: number;
  }>;
  filters: Array<{
    group: string;
    value: boolean;
  }>;
  facets: Array<{
    group: string;
    value: string;
  }>;
  userInsuranceAliasValues: string[];
  input: string;
}

export interface RecentSearch {
  date: string;
  searchParams: ProviderSearchOptions;
  key: string;
  searchQuery: string;
}

// keys are stored in the format: '@RECENT_SEARCHES_123456789_truncated_search_term
export const getQueryKey = (userId: string, query: string) =>
  `${STORAGE_KEY}_${userId}_${query.replace(/[^A-Za-z0-9]/g, '').toLowerCase()}`;

export const newRecentSearch = (userId: string, query: string, params: any) => {
  return {
    date: new Date(),
    searchParams: params,
    key: getQueryKey(userId, query),
    searchQuery: query
  } as RecentSearch;
};
